module.exports = __webpack_public_path__ + "static/media/rainbow.5eb0fa0a.svg";